(function ($) {

    $.fn.displaytag = function () {

        const options = {
            multiple: 0,
            html: '<div data-displaytag-click data-displaytag-libelle><div>',
            classSelected: 'displaytag-selected',
            classUnSelected: 'displaytag-unselected',
            classTagEnabled: 'displaytag-tag-enabled',
            classTagDisabled: 'displaytag-tag-disabled'
        };

        return this.each(function () {

            var myDisplayTag = $(this);
            var id = myDisplayTag.data('displaytag-id');

            var tags = myDisplayTag.data('displaytag-tags');

            var defaults = myDisplayTag.data('displaytag-defaults');

            var settings = options;

            for (let [key, value] of Object.entries(options)) {
                if (myDisplayTag.data('displaytag-options-' + key)) {
                    settings[key] = myDisplayTag.data('displaytag-options-' + key);
                }
            }

            function lire(key) {

                var jsonObj = JSON.parse(sessionStorage.getItem(id));

                return typeof jsonObj[key] === typeof undefined ? 0 : jsonObj[key];
            }

            function ecrire(key, value) {

                var jsonObj = JSON.parse(sessionStorage.getItem(id));

                jsonObj[key] = value;
                sessionStorage.setItem(id, JSON.stringify(jsonObj));
            }

            function addClass($items, cssClass) {
                $items.find('[data-displaytag-click]').addClass(cssClass) ||
                $items.filter('[data-displaytag-click]').addClass(cssClass);
            }

            function removeClass($items, cssClass) {
                $items.find('[data-displaytag-click]').removeClass(cssClass) ||
                $items.filter('[data-displaytag-click]').removeClass(cssClass);
            }

            function init() {
                $(myDisplayTag).empty();

                $storageExist=sessionStorage.getItem(id);
                if (!$storageExist) {
                    sessionStorage.setItem(id, JSON.stringify({}));
                }

                $.each(tags, function (index, data) {

                    $('.displaytag-value-' + data['code']).not("[displaytag-tag-checked]").attr('displaytag-tag-checked', 0);

                    var $html = $(settings.html);

                    var $click = $html.is('[data-displaytag-click]') ?
                        $html :
                        $html.find('[data-displaytag-click]');

                    var $libelle = $html.is('[data-displaytag-libelle]') ?
                        $html :
                        $html.find('[data-displaytag-libelle]');

                    if (!lire(data['code'])) {
                        var $items = $('.displaytag-value-' + data['code']).not("[displaytag-tag-checked='0']");
                        $items.each(function () {
                            nb = parseInt($(this).attr('displaytag-tag-checked'));
                            $(this).attr('displaytag-tag-checked', nb + 1);
                        })
                    }

                    $html
                        .attr('displaytag-checked', 1)
                        .attr('displaytag-checked', lire(data['code']) ? 0 : 1)
                        .attr('displaytag-value', data['code'])
                        .appendTo($(myDisplayTag))
                        .bind('refresh', function () {
                            var value = $(this).attr('displaytag-value');
                            var checked = parseInt($(this).attr('displaytag-checked'));

                            $items = $('.displaytag-value-' + value);

                            $items.each(function () {

                                nb = parseInt($(this).attr('displaytag-tag-checked'));
                                $(this).attr('displaytag-tag-checked', nb + (checked ? 1 : (!nb ? 0 : -1)));

                                if (parseInt($(this).attr('displaytag-tag-checked'))) {
                                    $(this).addClass(settings.classTagEnabled);
                                    $(this).removeClass(settings.classTagDisabled);
                                } else {
                                    $(this).addClass(settings.classTagDisabled);
                                    $(this).removeClass(settings.classTagEnabled);
                                }

                            });
                        })
                        .bind('change', function () {
                            var value = $(this).attr('displaytag-value');
                            var checked = parseInt($(this).attr('displaytag-checked')) ? 0 : 1;

                            $(this).attr('displaytag-checked', checked);

                            if (checked) {
                                addClass($(this), settings.classSelected);
                                removeClass($(this), settings.classUnSelected);
                            } else {
                                addClass($(this), settings.classUnSelected);
                                removeClass($(this), settings.classSelected);
                            }

                            ecrire(value, checked);
                            $(this).trigger('refresh');
                        })
                        .trigger('change');

                    $click.bind('click', function () {
                        var value = $html.attr('displaytag-value');
                        value = value.replace(/([ #;?&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');

                        $('[data-displaytag-id]').each(function () {
                            if ($(this).data('displaytag-options-multiple') == 0 && $(this).find('[displaytag-value="' + value + '"]').length) {
                                $(this).find(':not([displaytag-value="' + value + '"])').each(function () {
                                    if ($(this).attr('displaytag-checked') == 1) {
                                        $('[displaytag-value="' + $(this).attr('displaytag-value') + '"]').trigger('change');
                                    }
                                });
                            }
                        })

                        var $items = $('[displaytag-value="' + value + '"]');
                        $items.each(function () {
                            $(this).trigger('change');
                        });
                    });

                    $libelle.text(data['libelle']);

                });

                if (!$storageExist) {
                    $.each(defaults, function (index, data) {
                        var value = data['code'];
                        myDisplayTag.find('[displaytag-value="' + value + '"]').is('[data-displaytag-click]') ?
                            myDisplayTag.find('[displaytag-value="' + value + '"]').trigger('click') :
                            myDisplayTag.find('[displaytag-value="' + value + '"]').find('[data-displaytag-click]').trigger('click');
                    });
                }

            }

            init();

        });

    }

}(jQuery));
